<template>
  <article class="step-two" v-if="display">

    <button class="button blue-border back"
      @click="$emit('back', 1)"
    >
      Back to all Memberships
    </button>

    <p class="step-title">Would you like to add towel service?</p>

    <div class="terms-wrap">

      <div class="flex three-wide">

        <div class="term">
          <p class="title">Yes</p>

          <div class="prices">
            <div class="form-field radio" >
            <label>
              <input type="radio" :value="true" v-model="towel_type">
              <span>${{term.towel_cost}} <i>/ week</i></span>
            </label>
            </div>
          </div>
        </div>

        <div class="term">
          <p class="title">No</p>

          <div class="prices">
            <div class="form-field radio" >
            <label>
              <input type="radio" :value="false" v-model="towel_type">
              <span>I would not like to add towel service</span>
            </label>
            </div>
          </div>
        </div>

      </div>

      <div class="bottom flex flex-between">
        <button class="button blue-border" @click="$emit('back', 2)">Back</button>
        <button class="button light-blue" @click="finalStep">Next</button>
      </div>

    </div>

  </article>
</template>

<script>
export default {
  props: {
    term: Object,
    price: String
  },
  data () {
    return {
      duration: 'week',
      towel_type: false,
      display: true
    };
  },
  mounted () {

    if (this.price === this.term.monthly_cost) {
      this.duration = 'monthly'
    } else {
      this.duration = 'week'
    }

    if (this.term.towelable == false) {
      this.display = false
      if (this.duration === 'week') {
        window.location.href = this.term.signup_weekly_url
      } else {
        window.location.href = this.term.signup_monthly_url
      }
    }

  },
  methods: {
    finalStep () {
      if (this.duration === 'week') {

        if (this.towel_type) {
          window.location.href = this.term.signup_weekly_towel_url
        } else {
          window.location.href = this.term.signup_weekly_url
        }

      } else {

        if (this.towel_type) {
          window.location.href = this.term.signup_monthly_towel_url
        } else {
          window.location.href = this.term.signup_monthly_url
        }

      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/memberships/StepThree.vue